<template>
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 20px">
        <h4 style="margin-bottom: 0;">Danh sách học viên đăng ký thi IDP</h4>
        <div style="display: flex; gap: 10px; align-items: center">
            <button class="btn btn-success font-weight-bold" @click="$emit('openImport')">
                <i class="el-icon-upload2"></i> Import
            </button>
            <el-button
                :loading="isExporting"
                class="text-white"
                style="border: none"
                type="primary"
                @click="exportIdpExamRegister"
            >
                <i class="el-icon-download text-white"></i>
                <span v-if="!isExporting">Export</span>
                <span v-else>{{ percent }}%</span>
            </el-button>
            <button class="btn btn-purple font-weight-bold text-white" @click="$emit('openCreate')">
                <i class="el-icon-plus"></i> Đăng ký thi
            </button>
        </div>
    </div>
</template>

<script>
import {exportExcel} from "@/core/filters";
import {GET_LIST_IDP_EXAM_REGISTER} from "@/core/services/store/idp-exam-register/idpExamRegister.module";
import {IdpExamRegisterModel} from "../model/IdpExamRegisterModel";

const HEADER_ROW_EXPORT_IDP_EXAM_REGISTER = [
    {key: "logCode", value: "Mã log"},
    {key: "studentName", value: "Học viên"},
    {key: "studentCode", value: "Mã học viên"},
    {key: "phone", value: "Số điện thoại"},
    {key: "studentAddress", value: "Địa chỉ"},
    {key: "branchName", value: "Chi nhánh"},
    {key: "taskTime", value: "Thời gian sinh tác vụ"},
    {key: "examUnit", value: "Đơn vị thi"},
    {key: "payment_amount", value: "Số tiền đóng"},
    {key: "idp_payment_amount", value: "Số tiền IDP"},
    {key: "idpTransferAreaLabel", value: "Khu vực cần chuyển khoản IDP"},
    {key: "idpDueAtDisplay", value: "Thời hạn cần chuyển khoản IDP"},
    {key: "note", value: "Ghi chú"},
    {key: "paymentMethod", value: "Hình thức thanh toán"},
    {key: "statusLabel", value: "Trạng thái"},
    {key: "paidAt", value: "Thời gian đóng phí (mới nhất)"},
    {key: "paymentDatesExport", value: "Các lần thanh toán"},
    {key: "transactionCodesExport", value: "Mã giao dịch CK"},
];

export default {
    name: "HeaderManageIdpExamRegister",
    data() {
        return {
            isExporting: false,
            percent: 0,
        };
    },
    methods: {
        parseStatusFromQuery(status) {
            if (status === undefined || status === null || status === "") return null;
            if (Array.isArray(status)) {
                const arr = status.map((s) => Number(s)).filter((n) => !isNaN(n));
                return arr.length ? arr : null;
            }
            try {
                const arr = JSON.parse(`[${status}]`).map((s) => Number(s)).filter((n) => !isNaN(n));
                return arr.length ? arr : null;
            } catch {
                const n = Number(status);
                return isNaN(n) ? null : [n];
            }
        },
        parseListPage(res) {
            if (res?.error) return null;
            const pageObj = res?.data?.data ? res.data : res?.pagination ? res.pagination : res?.data;
            const rows = pageObj?.data ?? res?.data ?? [];
            return {
                rows: Array.isArray(rows) ? rows : [],
                last_page: Number(pageObj?.last_page || 1),
            };
        },
        formatCurrency(amount) {
            const num = Number(amount);
            return isNaN(num) ? amount : num.toLocaleString("vi-VN") + " đ";
        },
        paymentMethodLabel(method) {
            switch ((method || "").toString()) {
                case "cash":
                    return "Tiền mặt";
                case "transfer":
                    return "Chuyển khoản";
                case "card":
                    return "Quẹt thẻ";
                default:
                    return method || "";
            }
        },
        mapExportRow(item) {
            return {
                logCode: item.logCode,
                studentName: item.studentName,
                studentCode: item.studentCode || "—",
                phone: item.phone,
                studentAddress: item.studentAddress || "—",
                branchName: item.branchName,
                taskTime: item.taskTime,
                examUnit: item.examUnit,
                payment_amount: this.formatCurrency(item.payment_amount),
                idp_payment_amount: this.formatCurrency(item.idp_payment_amount),
                idpTransferAreaLabel: item.idpTransferAreaLabel || "—",
                idpDueAtDisplay: item.idpDueAtDisplay || "—",
                note: item.note || "—",
                paymentMethod: this.paymentMethodLabel(item.paymentMethod),
                statusLabel: item.statusLabel,
                paidAt: item.paidAtDisplay || item.paidAt || "—",
                paymentDatesExport: item.paymentDatesExport || "—",
                transactionCodesExport: item.transactionCodesExport || "—",
            };
        },
        buildExportPayload(page) {
            const q = this.$route.query || {};
            return {
                page,
                per_page: 1000,
                keyword: q.keyword ?? null,
                status: this.parseStatusFromQuery(q.status),
                from_date: q.from_date ?? null,
                to_date: q.to_date ?? null,
            };
        },
        async exportIdpExamRegister() {
            this.isExporting = true;
            try {
                const firstRes = await this.$store.dispatch(GET_LIST_IDP_EXAM_REGISTER, this.buildExportPayload(1));
                const firstPage = this.parseListPage(firstRes);
                if (!firstPage) {
                    this.$bvToast.toast(firstRes?.message || "Export thất bại", {
                        title: "Export excel",
                        variant: "danger",
                        solid: true,
                    });
                    return;
                }

                const totalPages = firstPage.last_page;
                let exportRows = firstPage.rows.map((item) =>
                    this.mapExportRow(new IdpExamRegisterModel(item))
                );
                this.percent = totalPages > 0 ? Math.round((1 / totalPages) * 100) : 0;

                for (let page = 2; page <= totalPages; page++) {
                    const pageRes = await this.$store.dispatch(GET_LIST_IDP_EXAM_REGISTER, this.buildExportPayload(page));
                    const pageData = this.parseListPage(pageRes);
                    if (!pageData) continue;
                    const pageRows = pageData.rows.map((item) =>
                        this.mapExportRow(new IdpExamRegisterModel(item))
                    );
                    exportRows = [...exportRows, ...pageRows];
                    this.percent = Math.min(100, Math.round((page / totalPages) * 100));
                }

                this.percent = 100;
                exportExcel(
                    HEADER_ROW_EXPORT_IDP_EXAM_REGISTER,
                    exportRows,
                    "Danh sách đăng ký thi IDP.xlsx",
                    false
                );
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e, "error");
                this.$bvToast.toast("Export thất bại", {
                    title: "Export excel",
                    variant: "danger",
                    solid: true,
                });
            } finally {
                this.isExporting = false;
                setTimeout(() => {
                    this.percent = 0;
                }, 500);
            }
        },
    },
};
</script>

<style scoped>
.btn-purple {
    background: #5e00b6;
}

.btn-purple:hover {
    background: #4d0095;
}
</style>
